import React, { useRef, useEffect, useState } from "react";
import ReactGA from "react-ga4";

import { Link, useLocation } from "react-router-dom";
import image1 from "../assets/image1.jpg";
import image2 from "../assets/image2.jpg";
import image3 from "../assets/image3.jpg";
import image4 from "../assets/image4.jpg";
import heroImg from "../assets/hero_woman_green.jpg";
import image5 from "../assets/image5.jpg";
import image6 from "../assets/image6.jpg";
import image7 from "../assets/image7.jpg";
import image8 from "../assets/image8.jpg";
const images = [
    image1,
    image2,
    image3,
    image4,
    heroImg,
    image5,
    image6,
    image7,
    image8
];

export default function LandingPage() {
    const horizScrollRef = useRef(null);
    const vertScrollRef = useRef(null);
    const headerRef = useRef(null);
    const socialProofRef = useRef(null);
    const [scrollHeight, setScrollHeight] = useState(400);
    const location = useLocation();
    const queryString = location.search;

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
    }, []);
    // Dynamically set the height of the vertical image scroll area (desktop)
    useEffect(() => {
        function updateHeight() {
            if (headerRef.current && socialProofRef.current) {
                const headerBottom = headerRef.current.getBoundingClientRect().bottom + window.scrollY;
                const socialProofTop = socialProofRef.current.getBoundingClientRect().top + window.scrollY;
                const height = socialProofTop - headerBottom - 20; // 20px margin
                setScrollHeight(height > 0 ? height : 400);
            }
        }
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    // Horizontal auto-scroll for mobile
    useEffect(() => {
        const scrollContainer = horizScrollRef.current;
        if (!scrollContainer) return;
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        if (!mediaQuery.matches) return;

        const totalImages = images.length;
        const imgEls = scrollContainer.querySelectorAll("img");
        const singleSetWidth = Array.from(imgEls)
            .slice(0, totalImages)
            .reduce((acc, img) => acc + img.offsetWidth + 12, 0);

        let animationFrameId;
        const scrollSpeed = 1;

        const step = () => {
            scrollContainer.scrollLeft += scrollSpeed;
            if (scrollContainer.scrollLeft >= singleSetWidth) {
                scrollContainer.scrollLeft = 0;
            }
            animationFrameId = requestAnimationFrame(step);
        };

        animationFrameId = requestAnimationFrame(step);
        return () => cancelAnimationFrame(animationFrameId);
    }, []);

    useEffect(() => {
        const scrollContainer = vertScrollRef.current;
        if (!scrollContainer) return;
        const mediaQuery = window.matchMedia('(min-width: 768px)');
        if (!mediaQuery.matches) return;

        const totalImages = images.length;
        const imgEls = scrollContainer.querySelectorAll("img");
        const singleSetHeight = Array.from(imgEls)
            .slice(0, totalImages)
            .reduce((acc, img) => acc + img.offsetHeight + 12, 0);

        let animationFrameId;
        const scrollSpeed = 1;

        const step = () => {
            scrollContainer.scrollTop += scrollSpeed;
            if (scrollContainer.scrollTop >= singleSetHeight) {
                scrollContainer.scrollTop = 0;
            }
            animationFrameId = requestAnimationFrame(step);
        };

        animationFrameId = requestAnimationFrame(step);
        return () => cancelAnimationFrame(animationFrameId);
    }, [scrollHeight]);

    return (
        <div className="font-sans bg-[#F6F5EC] min-h-screen flex flex-col">
            {/* Header */}
            <header
                ref={headerRef}
                className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white"
            >
                <div className="flex items-center space-x-2">
                    <span className="font-bold text-xl text-[#263A29]">OncoDiary /</span>
                    <span className="font-bold text-xl text-[#4B8F5A]">OncoDiet</span>
                </div>
                {/* <button className="text-2xl" aria-label="Open menu">&#9776;</button> */}
            </header>

            {/* Mobile: horizontal image scroll at the top */}
            <div className="block md:hidden bg-white border-b border-gray-200">
                <div
                    ref={horizScrollRef}
                    className="flex flex-row flex-nowrap space-x-3 overflow-x-auto pb-2 scrollbar-hide"
                    style={{ scrollBehavior: "auto" }}
                >
                    {[...images, ...images].map((src, idx) => (
                        <img
                            key={idx}
                            src={src}
                            alt=""
                            className="w-52 h-72 md:w-80 md:h-[28rem] rounded-lg object-cover flex-shrink-0"
                            draggable="false"
                        />
                    ))}
                </div>
            </div>

            {/* Desktop: two-column layout */}
            <div className="w-full flex flex-col md:flex-row">
                {/* Left: All content */}
                <div className="w-full md:w-3/4">
                    <section className="max-w-6xl mx-auto px-4 pt-2 pb-14 flex flex-col md:flex-row items-center">
                        <div className="w-full">
                            <h1
                                className="text-3xl md:text-5xl font-extrabold mb-5 leading-tight mt-8 text-left md:text-left
  "
                            >
                                Personalised
                                <br className="hidden md:block" />
                                <span className="text-[#4B8F5A]"> oncology-smart nutrition</span>
                                <br />
                                starts with a 7-minute quiz
                            </h1>

                            <Link
                                to={`/quiz/step/0${queryString ? queryString : ''}`}
                                className="inline-block w-full max-w-xs px-8 py-4 mb-4 rounded-full bg-[#4B8F5A] text-white text-lg text-center font-semibold shadow hover:bg-[#3d7a4b] transition md:mt-10"
                                >
                                Start the quiz
                            </Link>

                            <ul className="mb-4 space-y-1 text-xl">
                                <li>🕒 7 minutes to complete</li>
                            </ul>

                            <p className="text-xl mb-1">
                                Answer a handful of questions about your tastes, symptoms and goals.
                                We’ll preview a dietitian-designed meal plan tailored to you.
                                You only purchase if you decide to activate the full plan.
                            </p>
                        </div>
                    </section>
                </div>

                {/* Right: Vertical image scroll (only on desktop) */}
                <div className="hidden md:block md:w-[600px] md:ml-6 md:py-0">
                    <div
                        ref={vertScrollRef}
                        style={{ height: scrollHeight, overflowY: "auto" }}
                        className="flex flex-col flex-nowrap space-y-3 scrollbar-hide"
                    >
                        {[...images, ...images].map((src, idx) => (
                            <img
                                key={idx}
                                src={src}
                                alt=""
                                className="w-full h-40 md:w-160 md:h-[28rem] rounded-lg object-cover flex-shrink-0"
                                draggable="false"
                            />
                        ))}
                    </div>
                </div>
            </div>


            {/* FULL-WIDTH Social Proof (and all below) */}
            <section
                ref={socialProofRef}
                className="bg-[#E9F2EB] py-4 w-full"
            >
                <div className="px-4 flex flex-wrap justify-center gap-6 text-md font-medium">
                    <span>🧑‍⚕️ Dietitian-designed & evidence-based</span>
                    <span>🌱 Supporting you from day one</span>
                </div>
            </section>

            {/* HOW IT WORKS (full width) */}
            <section className="w-full py-4 bg-white">
                <div className="px-4">
                    <h2 className="text-3xl font-bold text-center mb-4">Your 4-step journey</h2>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-10">
                        {[
                            ["1 · Quiz", "Share tastes, symptoms and lifestyle facts."],
                            ["2 · Preview", "Instant glimpse of your tailored nutrition plan."],
                            ["3 · Checkout", "Activate your plan and start eating with confidence."],
                            ["4 · Support", "Get weekly recommendations and recipe emails."]
                        ].map(([title, desc]) => (
                            <div key={title} className="text-center px-4 py-6 bg-[#F0F8F3] rounded-lg shadow-md bg-[#F0F8F3] hover:bg-[#F0F8F3] transition">
                                <h3 className="text-2xl font-semibold mb-3 text-[#4B8F5A]">{title}</h3>
                                <p className="text-gray-700 text-xl leading-relaxed">{desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA BAR (full width) */}
            <section className="bg-[#4B8F5A] py-10 w-full">
                <div className="px-4 text-center">
                    <h3 className="text-2xl font-bold text-white mb-4">
                        Ready to see your personalised plan preview?
                    </h3>
                    <Link
                        to="/quiz?step=0"
                        className="inline-block bg-white text-[#4B8F5A] font-semibold text-xl px-8 py-4 rounded-lg shadow hover:bg-[#F0F8F3] transition"
                    >
                        Begin the 7-minute quiz
                    </Link>
                    <p className="mt-3 text-md text-[#F0F8F3]">
                        No commitment until you view your plan.
                    </p>
                </div>
            </section>

            {/* ---------- LEGAL FOOTER ---------- */}
            <footer className="bg-[#E9F2EB] py-6 text-center text-xs text-[#48554A] w-full">
                <div className="px-4 max-w-3xl mx-auto">
                    <p className="leading-relaxed">
                        This site does not offer medical advice. Always prioritize your health and safety,
                        and consult a healthcare professional with any health concerns.
                        This program has not been evaluated by the FDA and is not intended to diagnose,
                        treat, cure, or prevent any disease.
                    </p>
                    <div className="mt-4 space-x-4">
                        <Link to="/terms" className="underline hover:text-[#4B8F5A] transition">Terms of Use</Link>
                        <span className="text-gray-400">|</span>
                        <Link to="/privacy" className="underline hover:text-[#4B8F5A] transition">Privacy Policy</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}
